export const GENERAL_MESSAGE            = 'GENERAL_MESSAGE';
export const API_MESSAGE                = 'API_MESSAGE';
export const NEWSLETTER                 = 'NEWSLETTER';
export const APP_DOWNLOAD               = 'APP_DOWNLOAD';
export const SEND_LINK                  = 'SEND_LINK';
export const MEMBERSHIP_CHECK           = 'MEMBERSHIP_CHECK';
export const MEMBERSHIP_CHECK_DOWNLOAD  = 'MEMBERSHIP_CHECK_DOWNLOAD';
export const CARD_CHECK                 = 'CARD_CHECK';
export const LOGIN                      = 'LOGIN';
export const ACQUIRED                   = 'ACQUIRED';
export const PAYMENT                    = 'PAYMENT';
export const NEW_PAYMENT                = 'NEW_PAYMENT';
export const DELETE_CARD                = 'DELETE_CARD';
export const PHONE_VALIDATION           = 'PHONE_VALIDATION';
export const RADIO_OPTIONS              = 'RADIO_OPTIONS';
export const MAP_VIEW                   = 'MAP_VIEW';
export const PURCHASE_APPROVAL          = 'PURCHASE_APPROVAL';
export const FILE_UPLOAD_POPUP          = 'FILE_UPLOAD_POPUP';
export const ADD_ADDRESS_POPUP          = 'ADD_ADDRESS_POPUP';
export const ADD_CREDIT_CARD_POPUP      = 'ADD_CREDIT_CARD_POPUP';
export const CAR_LEAD_FORM_POPUP        = 'CAR_LEAD_FORM_POPUP';
export const LEAD_PAGE_TERMS_OF_SERVICE = 'LEAD_PAGE_TERMS_OF_SERVICE';
export const VIDEO_ARTICLE              = 'VIDEO_ARTICLE';
export const TRAVEL_INSURANCE_POPUP     = 'TRAVEL_INSURANCE_POPUP';
export const WAIVER_AGREEMENT           = 'WAIVER_AGREEMENT';
export const DATA_SHARING_POPUP         = 'DATA_SHARING_POPUP';

export const DATA_SHARING_SUBSIDY_POPUP = 'DATA_SHARING_SUBSIDY_POPUP';

export const IFRAME_POPUP               = 'IFRAME_POPUP';
export const SHARE_LINK_POPUP           = 'SHARE_LINK_POPUP';

export const CREATE_FORUM_POST_POPUP    = 'CREATE_FORUM_POST_POPUP';
export const IMAGE_POPUP                = 'IMAGE_POPUP';
export const SUBSIDY_POPUP              = 'SUBSIDY_POPUP';
export const REGISTRATION_PHONE_VALIDATION = 'REGISTRATION_PHONE_VALIDATION';
